import Api from 'api/v2/Api';
import PolicyTemplateApi from 'client/api/v2/PolicyTemplateApi';

const basePath = '/api/v2/durt/settings';

export class JumpcloudGoApi extends Api {
  async fetchPolicies() {
    // Get policy management details
    const skip = null;
    const limit = 100;
    const sort = 'display_name';
    const searchTerm = null;
    const windowsFilter = [
      {
        name: 'os_meta_family',
        operator: 'eq',
        value: 'WINDOWS',
      },
      {
        name: 'name',
        operator: 'eq',
        value: 'chrome_force_extensions_windows',
      },
    ];
    const darwinFilter2 = [
      {
        name: 'os_meta_family',
        operator: 'eq',
        value: 'DARWIN',
      },
      {
        name: 'name',
        operator: 'eq',
        value: 'google_chrome_browser_force_installed_extension_list_darwin',
      },
    ];

    const policyRequests = [];

    policyRequests.push(PolicyTemplateApi.fetch(
      skip,
      limit,
      sort,
      searchTerm,
      null,
      darwinFilter2,
    ));

    policyRequests.push(PolicyTemplateApi.fetch(
      skip,
      limit,
      sort,
      searchTerm,
      null,
      windowsFilter,
    ));

    const req = await Promise.all(policyRequests).then((res) => {
      const policies = { darwin: [], windows: [] };

      if (res[0] && res[0].results) {
        policies.darwin = res[0].results;
      }

      if (res[1] && res[1].results) {
        policies.windows = res[1].results;
      }

      return policies;
    }).catch((error) => {
      throw error;
    });

    return req;
  }

  async fetch() {
    // GET request returns the Jumpcloud Go feature object
    const { data } = await this.axios.get(`${basePath}`);
    return data;
  }

  update(settings) {
    // PUT request updates the Jumpcloud Go feature
    return this.axios.put(`${basePath}`, settings);
  }
}

export default new JumpcloudGoApi();
